import { useNavigate, useSearchParams } from 'react-router-dom'
import MusicalBackground from '../../components/MusicalBackground'
import { Layout, Flex, Card, Input, Button, Form, message } from 'antd'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import { attemptSetAdminPassword, SetNewPasswordDto } from '../../utils/redux/authSlice'
import { useAttemptListener } from 'dev-masters-react-kit'

type NewPasswordForm = SetNewPasswordDto & {
  confirmPassword: SetNewPasswordDto['newPassword']
}

export default function ResetAdminPassword() {
  const [searchParams] = useSearchParams()
  const dispatch = useAppDispatch()
  const [newPasswordForm] = Form.useForm<NewPasswordForm>()
  const navigate = useNavigate()

  const token = searchParams.get('token')

  function onSetNewPassword({ newPassword }: NewPasswordForm) {
    if (!token) {
      message.error('Url is invalid. Please use the link from the email.')
      return
    }
    dispatch(attemptSetAdminPassword({ token, newPassword }))
  }

  useAttemptListener({
    attempt: attemptSetAdminPassword,
    listenerMiddleware,
    onFulfilled: () => {
      message.success('Password has been successfully updated.')
      navigate('/')
    },
    onRejected() {
      message.error('Failed to set new password reset. Please try again later.')
    },
  })

  const currentNewPassword = Form.useWatch('newPassword', newPasswordForm)

  return (
    <>
      <MusicalBackground />
      <Layout>
        <Flex flex={1} justify="center" align="center">
          <Card>
            <Form onFinish={onSetNewPassword}>
              <Form.Item
                name="newPassword"
                rules={[
                  {
                    validator(_, value) {
                      //   const notPassed = verifyProvidedPassword(value)
                      //   if (notPassed) return Promise.reject(new Error(notPassed))
                      return Promise.resolve()
                    },
                  },
                ]}
              >
                <Input.Password placeholder={'New Password'} autoComplete="off" />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                dependencies={['newPassword']}
                rules={[
                  {
                    required: currentNewPassword?.length > 0,
                    message: 'Please confirm your password!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('newPassword') === value) {
                        return Promise.resolve()
                      }
                      return Promise.reject(new Error('The passwords are different'))
                    },
                  }),
                ]}
              >
                <Input.Password placeholder={'Repeat New Password'} autoComplete="off" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Set new password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  )
}
